<div id="layout">
  <app-terms-of-service></app-terms-of-service>
  <div class="tabstrip-container">
    <kendo-appbar position="top" themeColor="dark">
      <kendo-appbar-section>
        <app-tier-selector
          *ngIf="isAdminUser != null && !isAdminUser"
          [hidden]="tierSelectorVisible === 0"
        ></app-tier-selector>

        <app-concept-selector
          *ngIf="isAdminUser != null && isAdminUser"
        ></app-concept-selector>
      </kendo-appbar-section>
      <kendo-appbar-spacer></kendo-appbar-spacer>

      <kendo-appbar-section>
        <div class="tabs-container">
          <button
            *ngFor="let tab of tabs; let index = index"
            kendoButton
            (click)="onTabSelect(tab)"
            [fillMode]="selectedTabIndex == index ? 'solid' : 'flat'"
          >
            {{ tab.name }}
          </button>
        </div>
      </kendo-appbar-section>
      <kendo-appbar-spacer></kendo-appbar-spacer>
      <ng-container *ngIf="isAdminUser != null && !isAdminUser">
        <kendo-appbar-section class="buttons-section">
          <app-alerts-banner></app-alerts-banner>
          <app-sync-button></app-sync-button>
        </kendo-appbar-section>
      </ng-container>
    </kendo-appbar>
    <div class="k-loading-panel" *ngIf="isLoading">
      <div class="k-loading-panel-mask"></div>
      <div class="k-loading-panel-wrapper">
        <kendo-loader></kendo-loader>
        <div class="k-loading-panel-text">Loading...</div>
      </div>
    </div>
  </div>
  <app-validation-result></app-validation-result>
  <router-outlet></router-outlet>
</div>
